export interface IPeriodicWave {} // tslint:disable-line:no-empty-interface
